// The clock of a live session (plugins/sensor/sensor.js liveSession): seconds
// ridden, pauses left out. Pure, no '@/' import.
//
// While paused, the session's 1 s tick is stopped (now.time is cleared), so the
// clock stands at the start of the open pause: frozen, never NaN. The program
// screen reads it, and a program clock that kept running through a pause would
// count the pause as riding.

/** Milliseconds spent in pauses: a pause still open runs to now.time, or counts for nothing without it. */
export const pausedMilliseconds = (session) =>
    (session?.pauses ?? []).reduce((acc, { from, to }) => {
        const pauseFrom = Number(from)
        const pauseTo = Number(to ?? session.now?.time)
        if (!Number.isFinite(pauseFrom) || !Number.isFinite(pauseTo)) {
            return acc
        }
        return acc + Math.max(0, pauseTo - pauseFrom)
    }, 0)

/** Seconds ridden: up to the open pause while paused, up to the end once stopped, else up to now.time. */
export const liveSessionSeconds = (session) => {
    if (!session?.startedAt) return 0
    const lastPause = session.paused ? session.pauses?.at(-1) : null
    const openPauseFrom = lastPause && (lastPause.to ?? null) === null ? lastPause.from : undefined
    if (openPauseFrom !== undefined) {
        // The open pause is where the clock stops: only the pauses before it count.
        const before = pausedMilliseconds({ pauses: session.pauses.slice(0, -1) })
        return parseInt((openPauseFrom - session.startedAt - before) / 1000)
    }
    const end = session.endedAt ?? session.now?.time
    return parseInt((end - session.startedAt - pausedMilliseconds(session)) / 1000)
}
